import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { speechLocale } from "../../helpers/locale"

export default class extends BridgeComponent {
  static component = "voice"

  start() {
    const lang = speechLocale()
    console.log("[Voice] → sending start, lang:", lang)
    this.send("start", { language: lang }, (message) => {
      const { event, data } = message
      console.log("[Voice] ← callback event:", event, data)
      if (event === "ready") {
        this._modalController?._handleNativeReady({})
      } else if (event === "partial") {
        this._modalController?._handleNativePartial({ detail: { transcript: data.transcript } })
      } else if (event === "transcript") {
        this._modalController?._handleNativeTranscript({ detail: { transcript: data.transcript, error: null } })
      } else if (event === "error") {
        // The native side sends the stable error CODE in `data.code` (see
        // VoiceBridgeComponent.ErrorData), NOT `data.error`. Reading the wrong
        // field made the error undefined, so the modal's error branch never ran
        // (e.g. dictation-disabled message never showed, mascot stuck "on").
        this._modalController?._handleNativeTranscript({ detail: { transcript: null, error: data.code } })
      }
    })
  }

  stop() {
    console.log("[Voice] → sending stop")
    this.send("stop", {})
  }
}
